import type { DataTableColumn } from '@/components/ui/data-table-customized'
import { Resource } from '../../../types'

export const getResourceColumns = (): DataTableColumn<Resource>[] => [
    {
        key: 'name',
        title: 'Name',
        width: 200,
    },
    {
        key: 'displayName',
        title: 'Display Name',
        width: 300,
        valueGetter: (row) => row.displayName || '-',
    },
    {
        key: 'type',
        title: 'Type',
        width: 250,
        valueGetter: (row) => row.type || '-',
    },
    {
        key: 'uris',
        title: 'URIs',
        width: 300,
        render: (_, row) => {
            const uris = row.uris || []
            const display = uris.slice(0, 2).join(', ') || '-'
            const more = uris.length > 2 ? ` +${uris.length - 2} more` : ''
            return (
                <span>
                    {display}
                    {more}
                </span>
            )
        },
    },
    {
        key: 'scopes',
        title: 'Scopes',
        width: 150,
        valueGetter: (row) => `${row.scopes?.length || 0} scopes`,
    },
    {
        key: 'owner',
        title: 'Owner',
        width: 200,
        valueGetter: (row) => row.owner?.name || '-',
    },
]
